import React, { useState, useEffect } from "react";
import { Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Container,
  Card,
  CardBody,
} from "reactstrap";
import Instructions from "./instructions";
import usePermission from "hooks/usePermission";
import {
  getSettings,
  updateRewardSystemSettings,
  recalculateRewards,
} from "store/actions";
import LoadingButton from "../../../components/shared/LoadingButton";
import { toast } from "react-toastify";

const RewardSystemSettings = () => {
  const dispatch = useDispatch();
  const { settings, loading, error } = useSelector(({ Settings }) => Settings);
  const { hasPermission } = usePermission();
  const permissions = {
    add: false,
    edit: hasPermission("edit_reward_system_setting"),
    delete: false,
  };

  const [fields, setFields] = useState({
    minWeeklyBudget: 0,
    jackpotPercent: 0, //25%
    jackpotVisiblePercent: 0, //70%
    jackpotReservedPercent: 0, //30%
    grandJackpotPercent: 0, //60%
    majorJackpotPercent: 0, //30%
    minorJackpotPercent: 0, //10%
    // gamePercent: 0, //50%
    // leaderboardPercent: 0, //25%
    // leaderboardRank1Percent: 0, //18%
    // leaderboardRank2Percent: 0, //16%
    // leaderboardRank3Percent: 0, //15%
    // leaderboardRank4Percent: 0, //13%
    // leaderboardRank5Percent: 0, //11%
    // leaderboardRank6Percent: 0, //9%
    // leaderboardRank7Percent: 0, //7%
    // leaderboardRank8Percent: 0, //5%
    // leaderboardRank9Percent: 0, //4%
    // leaderboardRank10Percent: 0, //2%
  });

  useEffect(() => {
    dispatch(getSettings());
  }, [dispatch]);

  useEffect(() => {
    if (settings?._id) {
      // console.info("settings", settings);
      const rewardSystem = settings.rewardSystem;
      setFields(() => ({
        minWeeklyBudget: rewardSystem?.minWeeklyBudget,
        jackpotPercent: rewardSystem?.jackpotPercent,
        jackpotVisiblePercent: rewardSystem?.jackpotVisiblePercent,
        jackpotReservedPercent: rewardSystem?.jackpotReservedPercent,
        grandJackpotPercent: rewardSystem?.grandJackpotPercent,
        majorJackpotPercent: rewardSystem?.majorJackpotPercent,
        minorJackpotPercent: rewardSystem?.minorJackpotPercent,
        // gamePercent: rewardSystem?.gamePercent,
        // leaderboardPercent: rewardSystem?.leaderboardPercent,
        // leaderboardRank1Percent: rewardSystem?.leaderboardRank1Percent,
        // leaderboardRank2Percent: rewardSystem?.leaderboardRank2Percent,
        // leaderboardRank3Percent: rewardSystem?.leaderboardRank3Percent,
        // leaderboardRank4Percent: rewardSystem?.leaderboardRank4Percent,
        // leaderboardRank5Percent: rewardSystem?.leaderboardRank5Percent,
        // leaderboardRank6Percent: rewardSystem?.leaderboardRank6Percent,
        // leaderboardRank7Percent: rewardSystem?.leaderboardRank7Percent,
        // leaderboardRank8Percent: rewardSystem?.leaderboardRank8Percent,
        // leaderboardRank9Percent: rewardSystem?.leaderboardRank9Percent,
        // leaderboardRank10Percent: rewardSystem?.leaderboardRank10Percent,
      }));
    }
  }, [settings]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFields((prev) => ({
      ...prev,
      [name]: Number(value),
    }));
  };

  const submit = async () => {
    const leaderboardTotal = Object.keys(fields)
      .filter((key) => key.startsWith("leaderboardRank"))
      .reduce((sum, key) => sum + Number(fields[key] || 0), 0);

    // if (leaderboardTotal !== 100) {
    //   console.warn(
    //     "The total of all leaderboard rank percentages must equal 100%",
    //   );
    //   return;
    // }
    const rewardSplitTotal =
      // Number(fields.gamePercent) +
      Number(fields.jackpotPercent);
    //+ Number(fields.leaderboardPercent);
    if (rewardSplitTotal > 100) {
      console.warn(
        "The total of jackpot percentages must equal or less than 100%",
      );
      return;
    }
    // if (rewardSplitTotal < 100) {
    //   const rewardSplit = window.confirm(
    //     // `Warning: The sum of gamePercent (${fields.gamePercent}%),
    //     //  jackpotPercent (${fields.jackpotPercent}%), and
    //     //  leaderboardPercent (${fields.leaderboardPercent}%) is ${rewardSplitTotal}%.
    //     `Warning : jackpotPercent should be 100%. Do you want to continue anyway?`,
    //   );
    //   if (!rewardSplit) return; // User chose not to continue
    // }
    const visibleSplitTotal =
      Number(fields.jackpotVisiblePercent) +
      Number(fields.jackpotReservedPercent);
    if (visibleSplitTotal < 100) {
      const visibleProceed = window.confirm(
        `Warning: The sum of jackpot visible percent (${fields.jackpotVisiblePercent}%), 
        jackpot reserved percent (${fields.jackpotReservedPercent}%) is ${visibleSplitTotal}%. 
        It should be 100%. Do you want to continue anyway?`,
      );
      if (!visibleProceed) return; // User chose not to continue
    }
    const jackpotSplitTotal =
      Number(fields.grandJackpotPercent) +
      Number(fields.majorJackpotPercent) +
      Number(fields.minorJackpotPercent);
    if (jackpotSplitTotal < 100) {
      const jackpotProceed = window.confirm(
        `Warning: The sum of grand jackpot percent (${fields.grandJackpotPercent}%), 
        major jackpot percent (${fields.majorJackpotPercent}%), and 
        minor jackpot percent (${fields.minorJackpotPercent}%) is ${jackpotSplitTotal}%. 
        It should be 100%. Do you want to continue anyway?`,
      );
      if (!jackpotProceed) return; // User chose not to continue
    }
    dispatch(
      updateRewardSystemSettings({
        data: { ...fields },
      }),
    );
  };

  const recalculateWeeklyRewards = async () => {
    const recalculateProceed = window.confirm(
      `Warning: Are you sure you want to recalculate weekly rewards. Do you want to continue?`,
    );
    if (!recalculateProceed) return;
    dispatch(
      recalculateRewards({
        data: {},
        callBack: (err, res) => {
          if (err) {
            console.info("re calculate error", err);
            toast.error(err);
          } else {
            console.info("response from recalculations =====>", res);
            setFields(res?.data);
          }
        },
      }),
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col sm={12} lg={12}>
              <Card>
                <CardBody className="spinner-content">
                  {error && typeof error === "string" ? (
                    <Alert color="danger">{error}</Alert>
                  ) : null}

                  {loading && <div className="spinner"></div>}

                  <div className="row d-flex align-items-center">
                    <Instructions />
                    <div className="col-lg-4 ms-auto text-end">
                      <LoadingButton
                        onClick={recalculateWeeklyRewards}
                        className="btn btn-primary btn-lg"
                        loading={loading}
                        disabled={loading}
                      >
                        {!loading ? <>Recalculate Weekly Rewards</> : ""}
                      </LoadingButton>
                    </div>
                  </div>

                  <Col lg={8}>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Weekly Min Budget</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="Weekly Min Budget"
                            value={fields?.minWeeklyBudget}
                            name="minWeeklyBudget"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>
                      {/* <Col md={6}>
                        <FormGroup>
                          <Label>Game Percentage</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="gamePercent"
                            value={fields?.gamePercent}
                            name="gamePercent"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col> */}

                      <Col md={6}>
                        <FormGroup>
                          <Label>Jackpot Percentage</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="jackpotPercent"
                            value={fields?.jackpotPercent}
                            name="jackpotPercent"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Jackpot Visible Percentage</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="jackpotVisiblePercent"
                            value={fields?.jackpotVisiblePercent}
                            name="jackpotVisiblePercent"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Jackpot Reserved Percentage</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="jackpotReservedPercent"
                            value={fields?.jackpotReservedPercent}
                            name="jackpotReservedPercent"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Grand Jackpot Percentage</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="grandJackpotPercent"
                            value={fields?.grandJackpotPercent}
                            name="grandJackpotPercent"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Major Jackpot Percentage</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="majorJackpotPercent"
                            value={fields?.majorJackpotPercent}
                            name="majorJackpotPercent"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Minor Jackpot Percentage</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="minorJackpotPercent"
                            value={fields?.minorJackpotPercent}
                            name="minorJackpotPercent"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      {/* <Col md={6}>
                        <FormGroup>
                          <Label>Leaderboard Percentage</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="leaderboardPercent"
                            value={fields?.leaderboardPercent}
                            name="leaderboardPercent"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col> */}

                      {/* <Col md={6}>
                        <FormGroup>
                          <Label>Leaderboard Rank 1 Percentage</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="leaderboardRank1Percent"
                            value={fields?.leaderboardRank1Percent}
                            name="leaderboardRank1Percent"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Leaderboard Rank 2 Percentage</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="leaderboardRank2Percent"
                            value={fields?.leaderboardRank2Percent}
                            name="leaderboardRank2Percent"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Leaderboard Rank 3 Percentage</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="leaderboardRank3Percent"
                            value={fields?.leaderboardRank3Percent}
                            name="leaderboardRank3Percent"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Leaderboard Rank 4 Percentage</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="leaderboardRank4Percent"
                            value={fields?.leaderboardRank4Percent}
                            name="leaderboardRank4Percent"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Leaderboard Rank 5 Percentage</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="leaderboardRank5Percent"
                            value={fields?.leaderboardRank5Percent}
                            name="leaderboardRank5Percent"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Leaderboard Rank 6 Percentage</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="leaderboardRank6Percent"
                            value={fields?.leaderboardRank6Percent}
                            name="leaderboardRank6Percent"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Leaderboard Rank 7 Percentage</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="leaderboardRank7Percent"
                            value={fields?.leaderboardRank7Percent}
                            name="leaderboardRank7Percent"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Leaderboard Rank 8 Percentage</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="leaderboardRank8Percent"
                            value={fields?.leaderboardRank8Percent}
                            name="leaderboardRank8Percent"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Leaderboard Rank 9 Percentage</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="leaderboardRank9Percent"
                            value={fields?.leaderboardRank9Percent}
                            name="leaderboardRank9Percent"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Leaderboard Rank 10 Percentage</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="leaderboardRank10Percent"
                            value={fields?.leaderboardRank10Percent}
                            name="leaderboardRank10Percent"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col> */}

                      <Col md={6} />
                      {permissions.edit ? (
                        <Col className="d-flex justify-content-end mt-3">
                          <LoadingButton
                            onClick={submit}
                            className="btn btn-primary btn-lg"
                            loading={loading}
                            disabled={loading}
                          >
                            {!loading ? <>Save Changes</> : ""}
                          </LoadingButton>
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default RewardSystemSettings;
